
// Navigation watcher removed; routes exported directly
import React from 'react';

const IslemSablonPage = React.lazy(() => import('./pages/ISLEM/ISLEM_SABLON'));
const IslemFiyatGirisiPage = React.lazy(() => import('./pages/ISLEM/IslemFiyatGirisi'));
const IslemFiyatListesiPage = React.lazy(() => import('./pages/ISLEM/IslemFiyatListesi'));
const IslemDokumanPanelPage = React.lazy(() => import('./pages/ISLEM/IslemDokumanPanel'));
const ProfilPage = React.lazy(() => import('./pages/PROFIL/profil'));
const HomePage = React.lazy(() => import('./pages/HOME/home'));
const KullaniciPage = React.lazy(() => import('./pages/KULLANICI/kullanici'));
const KullaniciIzinPage = React.lazy(() => import('./pages/KULLANICI/kullanici_izin'));
const RolPage = React.lazy(() => import('./pages/ROL/rol'));
const HakPage = React.lazy(() => import('./pages/HAK/hak'));
const EkranPage = React.lazy(() => import('./pages/EKRAN/ekran'));
const FirmaPage = React.lazy(() => import('./pages/FIRMA/firma'));
const SozlukPage = React.lazy(() => import('./pages/SOZLUK/sozluk'));
const UlkePage = React.lazy(() => import('./pages/ULKE/ulke'));
const IlPage = React.lazy(() => import('./pages/IL/il'));
const IlcePage = React.lazy(() => import('./pages/ILCE/ilce'));
const MeslekPage = React.lazy(() => import('./pages/MESLEK/meslek'));
const CariPaylastirPage = React.lazy(() => import('./pages/CARIPAYLASTIR/caripaylastir'));
const CariPaylastirKuralYonetimiPage = React.lazy(() => import('./pages/CARIPAYLASTIR/KuralYonetimi'));
const PrimPage = React.lazy(() => import('./pages/PRIM/prim'));
const PrimParametrePage = React.lazy(() => import('./pages/PRIM/prim_parametre'));
const PrimRaporPage = React.lazy(() => import('./pages/PRIM/prim_rapor'));
const CariPage = React.lazy(() => import('./pages/CARI/carilist'));
const EskiCariKartPage = React.lazy(() => import('./pages/ESKI_CARI/eski-carikart'));
const LegacyCariDfmPage = React.lazy(() => import('./pages/LEGACY_CARI_DFM/LegacyCariDfm'));
const DocSablonPage = React.lazy(() => import('./pages/DOCSABLON/DocSablon'));
const DocImzalaPage = React.lazy(() => import('./pages/DOCSABLON/DocImzalaPage'));
const CariTransferPage = React.lazy(() => import('./pages/CARITRANSFER/caritransfer'));
const SabitPage = React.lazy(() => import('./pages/SABIT/sabit'));
const BaglantiPage = React.lazy(() => import('./pages/BAGLANTI/baglanti'));
const MacPage = React.lazy(() => import('./pages/MAC/mac'));
const RaporDetayPage = React.lazy(() => import('./pages/RAPOR_DETAY/rapor_detay'));
const RaporGenelPage = React.lazy(() => import('./pages/RAPOR_GENEL/rapor_genel'));
const RaporBulDegPage = React.lazy(() => import('./pages/RAPOR_BULDEG/rapor_buldeg'));
const TarihcePage = React.lazy(() => import('./pages/TARIHCE/tarihce'));
const CronPage = React.lazy(() => import('./pages/CRON/cron'));
const KullaniciCariDevirPage = React.lazy(() => import('./pages/CRON/kullanici-cari-devir'));
const RaporSesPage = React.lazy(() => import('./pages/RAPOR_SES/rapor_ses'));
const RaporEkKanAlPage = React.lazy(() => import('./pages/RAPOR_EKKANAL/rapor_ekkanal'));
const RaporKullaniciAnalizPage = React.lazy(() => import('./pages/RAPOR_KULLANICIANALIZ/rapor_kullanicianaliz'));
const RaporMusteriAnalizPage = React.lazy(() => import('./pages/RAPOR_MUSTERIANALIZ/rapor_musterianaliz'));
const RaporAylikSatisPage = React.lazy(() => import('./pages/RAPOR_AYLIKSATIS/rapor_ayliksatis'));
const RaporGunlukSatisPage = React.lazy(() => import('./pages/RAPOR_GUNLUKSATIS/rapor_gunluksatis'));
const RaporSaatlikSatisPage = React.lazy(() => import('./pages/RAPOR_SAATLIKSATIS/rapor_saatliksatis'));
const RaporSatisDetayPage = React.lazy(() => import('./pages/RAPOR_SATISDETAY/rapor_satisdetay'));
const RaporSatisKupPage = React.lazy(() => import('./pages/RAPOR_SATIS_KUP/rapor_satis_kup'));
const RaporAtamaAnaliziPage = React.lazy(() => import('./pages/RAPOR_ATAMA_ANALIZI/rapor_atama_analizi'));
const RaporSsmediaCrmPage = React.lazy(() => import('./pages/RAPOR_SSMEDIA_CRM/rapor_ssmedia_crm'));
const RaporSsmediaCrmDetayPage = React.lazy(() => import('./pages/RAPOR_SSMEDIA_CRM/rapor_ssmedia_crm_detay'));
const RaporWhatsAppTopluPage = React.lazy(() => import('./pages/RAPOR_WHATSAPP_TOPLU/rapor_whatsapp_toplu'));
const RaporWhatsAppBildirimPage = React.lazy(() => import('./pages/RAPOR_WHATSAPP_BILDIRIM/rapor_whatsapp_bildirim'));
const RaporWhatsAppGorusmePage = React.lazy(() => import('./pages/RAPOR_WHATSAPP_GORUSME/rapor_whatsapp_gorusme'));
const RaporWhatsAppCevaplariPage = React.lazy(() => import('./pages/RAPOR_WHATSAPP_CEVAPLARI/rapor_whatsapp_cevaplari'));
const RaporCallCenterPage = React.lazy(() => import('./pages/RAPOR_CALLCENTER/rapor_callcenter'));
const RaporTemsilciOnayPage = React.lazy(() => import('./pages/RAPOR_TEMSILCI_ONAY/rapor_temsilci_onay'));
const AiWhatsAppKuyrukPage = React.lazy(() => import('./pages/AI_WHATSAPP_KUYRUK/ai_whatsapp_kuyruk'));

const routes = [
    {
      path: '/ISLEM_SABLON',
      component: IslemSablonPage
    },
    {
      path: '/ISLEMFIYATGIRISI',
      component: IslemFiyatGirisiPage
    },
    {
      path: '/ISLEMFIYATLISTESI',
      component: IslemFiyatListesiPage
    },
  {
    path: '/PROFIL',
    component: ProfilPage
  },
  {
    path: '/HOME',
    component: HomePage
  },  {
    path: '/ISLEMDOKUMANPANEL',
    component: IslemDokumanPanelPage
  },
  {
    path: '/KULLANICI',
    component: KullaniciPage
  },
  {
    path: '/KULLANICI_IZIN',
    component: KullaniciIzinPage
  },
  {
    path: '/ROL',
    component: RolPage
  },
  {
    path: '/HAK',
    component: HakPage
  },
  {
    path: '/EKRAN',
    component: EkranPage
  },
  {
    path: '/FIRMA',
    component: FirmaPage
  },
  {
    path: '/SOZLUK',
    component: SozlukPage
  },
  {
    path: '/ULKE',
    component: UlkePage
  },
  {
    path: '/IL',
    component: IlPage
  },
  {
    path: '/ILCE',
    component: IlcePage
  },
  {
    path: '/MESLEK',
    component: MeslekPage
  },
  {
    path: '/CARIPAYLASTIR',
    component: CariPaylastirPage
  },

  {
    path: '/CARIPAYLASTIR_KURAL_YONETIMI',
    component: CariPaylastirKuralYonetimiPage
  },
  {
    path: '/PRIM',
    component: PrimPage
  },
  {
    path: '/PRIM_PARAMETRE',
    component: PrimParametrePage
  },
  {
    path: '/PRIM_RAPOR',
    component: PrimRaporPage
  },
  {
    path: '/CARI',
    component: CariPage
  },
  {
    path: '/ESKI_CARI_KART',
    component: EskiCariKartPage
  },
  {
    path: '/LEGACY_CARI_DFM',
    component: LegacyCariDfmPage
  },
  {
    path: '/DOCSABLON',
    component: DocSablonPage
  },
  {
    path: '/docsablon/imzala',
    component: DocImzalaPage
  },
  {
    path: '/CARITRANSFER',
    component: CariTransferPage
  },
  {
    path: '/SABIT',
    component: SabitPage
  },
  {
    path: '/BAGLANTI',
    component: BaglantiPage
  },
  {
    path: '/MAC',
    component: MacPage
  },
  {
    path: '/RAPOR_DETAY',
    component: RaporDetayPage
  },
  {
    path: '/RAPOR_GENEL',
    component: RaporGenelPage
  }
  ,
  {
    path: '/RAPOR_BULDEG',
    component: RaporBulDegPage
  },
  {
    path: '/TARIHCE',
    component: TarihcePage
  },
  {
    path: '/CRON',
    component: CronPage
  },
  {
    path: '/KULLANICI_CARI_DEVIR',
    component: KullaniciCariDevirPage
  },
  {
    path: '/RAPOR_SES',
    component: RaporSesPage
  },
  {
    path: '/RAPOR_EKKANAL',
    component: RaporEkKanAlPage
  },
  {
    path: '/RAPOR_KULLANICIANALIZ',
    component: RaporKullaniciAnalizPage
  },
  {
    path: '/RAPOR_MUSTERIANALIZ',
    component: RaporMusteriAnalizPage
  },
  {
    path: '/RAPOR_AYLIKSATIS',
    component: RaporAylikSatisPage
  },
  {
    path: '/RAPOR_GUNLUKSATIS',
    component: RaporGunlukSatisPage
  },
  {
    path: '/RAPOR_SAATLIKSATIS',
    component: RaporSaatlikSatisPage
  },
  {
    path: '/RAPOR_SATISDETAY',
    component: RaporSatisDetayPage
  },
{
    path: '/RAPOR_SATIS_KUP',
    component: RaporSatisKupPage
  },
  {
    path: '/RAPOR_ATAMA_ANALIZI',
    component: RaporAtamaAnaliziPage
  },
  {
    path: '/RAPOR_SSMEDIA_CRM',
    component: RaporSsmediaCrmPage
  },
  {
    path: '/RAPOR_SSMEDIA_CRM_DETAY',
    component: RaporSsmediaCrmDetayPage
  },
  {
    path: '/RAPOR_SSMEDIA_DETAY',
    component: RaporSsmediaCrmDetayPage
  },
  {
    path: '/rapor_ssmedia_detay',
    component: RaporSsmediaCrmDetayPage
  },
  {
    path: '/RAPOR_WHATSAPP_TOPLU',
    component: RaporWhatsAppTopluPage
  },
  {
    path: '/RAPOR_WHATSAPP_BILDIRIM',
    component: RaporWhatsAppBildirimPage
  },
  {
    path: '/RAPOR_WHATSAPP_GORUSME',
    component: RaporWhatsAppGorusmePage
  },
  {
    path: '/RAPOR_WHATSAPP_CEVAPLARI',
    component: RaporWhatsAppCevaplariPage
  },
  {
    path: '/RAPOR_CALLCENTER',
    component: RaporCallCenterPage
  },
  {
    path: '/RAPOR_TEMSILCI_ONAY',
    component: RaporTemsilciOnayPage
  },
  {
    path: '/AI_WHATSAPP_KUYRUK',
    component: AiWhatsAppKuyrukPage
  }
];

export default routes;
